var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoFilesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43934 4.06066L6.87868 4.5H7.5H12.5C13.3284 4.5 14 5.17157 14 6V11C14 11.8284 13.3284 12.5 12.5 12.5H3.5C2.67157 12.5 2 11.8284 2 11V4.5C2 3.67157 2.67157 3 3.5 3H4.75736C5.15518 3 5.53672 3.15804 5.81802 3.43934L6.43934 4.06066ZM0.5 4.5C0.5 2.84315 1.84315 1.5 3.5 1.5H4.75736C5.55301 1.5 6.31607 1.81607 6.87868 2.37868L7.5 3H12.5C14.1569 3 15.5 4.34315 15.5 6V11C15.5 12.6569 14.1569 14 12.5 14H3.5C1.84315 14 0.5 12.6569 0.5 11V4.5ZM10.5303 9.03033C10.8232 8.73744 10.8232 8.26256 10.5303 7.96967C10.2374 7.67678 9.76256 7.67678 9.46967 7.96967L8.75 8.68934V6.5C8.75 6.08579 8.41421 5.75 8 5.75C7.58579 5.75 7.25 6.08579 7.25 6.5V8.68934L6.53033 7.96967C6.23744 7.67678 5.76256 7.67678 5.46967 7.96967C5.17678 8.26256 5.17678 8.73744 5.46967 9.03033L7.46967 11.0303C7.76256 11.3232 8.23744 11.3232 8.53033 11.0303L10.5303 9.03033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoFilesIcon);
export default __webpack_public_path__ + "static/media/DemoFilesIcon.cf52e092287a6f92710f424b31b80883.svg";
export { ForwardRef as ReactComponent };